import type { RouteRecordRaw } from "vue-router"

const callsReportRoutes: Array<RouteRecordRaw> = [
  {
    path: "/calls-report",
    name: "callsReport",
    children: [
      {
        path: "calls",
        name: "calls",
        component: () => import("@/views/calls-report/Calls.vue"),
        meta: {
          pageTitle: "Calls",
          breadcrumbs: ["Calls Report", "Calls"],
        },
      },
    ],
  },
  {
    path: "/visits-report",
    name: "visitsReport",
    children: [
      {
        path: "visits",
        name: "visits",
        component: () => import("@/views/visits-report/Visits.vue"),
        meta: {
          pageTitle: "Visits",
          breadcrumbs: ["Visits Report", "Visits"],
        },
      },
    ],
  },
  {
    path: "/calls-ringba-buyers",
    name: "ringbaBuyers",
    component: () => import("@/views/calls-report/RingbaBuyer.vue"),
    meta: {
      pageTitle: "Ringba Buyers",
      breadcrumbs: ["Ringba Buyers"],
    },
  },
]

export default callsReportRoutes
